import { render, staticRenderFns } from "./event-details.vue?vue&type=template&id=74d84da1&scoped=true&"
import script from "./event-details.vue?vue&type=script&lang=js&"
export * from "./event-details.vue?vue&type=script&lang=js&"
import style0 from "./event-details.vue?vue&type=style&index=0&id=74d84da1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d84da1",
  null
  
)

export default component.exports